// extracted by mini-css-extract-plugin
module.exports = {"foot":"PaginationGrowingFooter_foot__3zKVf"};